module.exports = __webpack_public_path__ + "img/age-confirm-bg-1.bfc2f0b9.png";